<template>
  <div class="container flex items-center justify-center gap-4 p-8 md:text-right">
    <a href="https://www.prodam.am.gov.br" target="_blank" class="inlin text-center md:mt-5 md:inline-block 2xl:mt-0">
      <img
        src="https://apstatic.prodam.am.gov.br/images/prodam/logo-prodam-horizontal.png"
        alt="PRODAM - Processamento de Dados Amazonas"
        class="inline w-24 md:w-32" />
    </a>

    <a href="https://www.detran.am.gov.br" target="_blank">
      <img
        src="https://apstatic.prodam.am.gov.br/images/detran/logo-detran-horizontal.png"
        alt="DETRAN Amazonas"
        class="mx-auto h-10 md:inline md:h-14" />
    </a>

    <a href="https://www.amazonas.am.gov.br" target="_blank">
      <img
        src="https://apstatic.prodam.am.gov.br/images/logo_governo/logo-gov-horizontal-assinatura.png"
        alt="Governo de Estado do Amazonas"
        class="mx-auto h-10 md:inline md:h-14" />
    </a>
  </div>
</template>
